function UserAccountIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2496 8.75C15.2496 10.5449 13.7945 12 11.9996 12C10.2047 12 8.74958 10.5449 8.74958 8.75C8.74958 6.95508 10.2047 5.5 11.9996 5.5C13.7945 5.5 15.2496 6.95508 15.2496 8.75ZM20.8555 16.6505C20.3859 17.5427 19.7841 18.3588 19.0705 19.0711C18.8304 19.3111 18.5784 19.5389 18.3155 19.7536C14.6392 22.7536 9.35978 22.7536 5.68348 19.7536C5.42053 19.5389 5.16855 19.3111 4.92848 19.0711C1.29833 15.44 1.00745 9.64995 4.25543 5.67338C7.5034 1.6968 13.2349 0.825716 17.5177 3.65776C21.8005 6.48981 23.2429 12.1048 20.8555 16.6505ZM19.9996 12C20.0057 8.43344 17.6501 5.29361 14.2242 4.30183C10.7983 3.31004 7.12969 4.70588 5.22953 7.72411C3.32936 10.7423 3.65667 14.6539 6.03203 17.3144L6.38738 14.8272C6.45516 14.3526 6.86164 14 7.34108 14H9.99958C9.97823 14.5367 10.1821 15.0579 10.5619 15.4377C10.9417 15.8175 11.4629 16.0214 11.9996 16C12.5363 16.0214 13.0575 15.8175 13.4373 15.4377C13.8171 15.0579 14.0209 14.5367 13.9996 14H16.6581C17.1375 14 17.544 14.3526 17.6118 14.8272L17.9671 17.3144C19.2782 15.855 20.0023 13.9618 19.9996 12Z"
        fill="#D40511"
      />
    </svg>
  );
}

export default UserAccountIcon;
